import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

type Props = {
  title?: string; readonly?: boolean; allowAdd?: boolean; allowDelete?: boolean; allowDuplicate?: boolean; allowPreview?: boolean;
  hasSelection?: boolean; submitting?: boolean; onAdd: () => void; onDuplicate: () => void; onDelete: () => void; onPreview: () => void; onSubmit: () => void;
};

const EditableGridToolbar: React.FC<Props> = ({ title, readonly, allowAdd, allowDelete, allowDuplicate, allowPreview, hasSelection, submitting, onAdd, onDuplicate, onDelete, onPreview, onSubmit }) => (
  <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={1} sx={{ mb: 1 }}>
    <Typography variant="h6">{title || 'Editable Grid'}</Typography>
    {!readonly && (
      <Stack direction="row" spacing={1}>
        {allowAdd && <Button size="small" variant="outlined" onClick={onAdd}>Add Row</Button>}
        {allowDuplicate && <Button size="small" variant="outlined" disabled={!hasSelection} onClick={onDuplicate}>Duplicate</Button>}
        {allowDelete && <Button size="small" color="error" variant="outlined" disabled={!hasSelection} onClick={onDelete}>Delete</Button>}
        {allowPreview && <Button size="small" variant="outlined" onClick={onPreview}>Preview JSON</Button>}
        <Button size="small" variant="contained" disabled={submitting} onClick={onSubmit}>Submit</Button>
      </Stack>
    )}
  </Stack>
);

export default EditableGridToolbar;
